/**
 * Checks if the path passed in is active based on the current pathname.
 */
export const isRouteActive = (
  path: string | undefined,
  expanded: boolean,
  isSubNavExpanded: boolean,
  isActive?: boolean, // override flag
  currentPathname?: string,
): boolean => {
  if (isActive) {
    return true;
  }

  if (!expanded && isSubNavExpanded) {
    return true;
  }

  if (!path) {
    return false;
  }
  const normalisedPath = path.split("?")[0]; // Remove query parameters
  const pathname = currentPathname ?? window.location.pathname;

  // Exact match
  if (pathname === normalisedPath) {
    // Skip currently if it's a saved view since we don't want them ever to be active
    if (path.includes("current_view_id=")) {
      return false;
    }
    return true;
  }
  // Sub-route match e.g. /notices matches /notices/analysis
  return pathname.startsWith(normalisedPath + "/");
};
